/* eslint-disable no-restricted-syntax */
import gql from 'graphql-tag'

export const FishTypeFragment = gql`
  fragment fish_type_fragment on FishType {
    name
    slug
    image {
      contentUrl
    }
  }
`

export const FisheryInfoFragment = gql`
  fragment fishery_info_fragment on FishingRegion {
    name
    id
    summary(format: HTML)
    forage(format: HTML)
    features(format: HTML)
    seasonalFishMovement(format: HTML)
  }
`

export const GuideFragment = gql`
  fragment guide_fragment on Guide {
    name
    id
    publisher {
      name
      copyright
      description
    }
  }
`

export const WaterbodySpeciesFragment = gql`
  fragment waterbody_species_fragment on FishSurveySummary {
    __typename
    abundanceSummary {
      surveyMethod
      classQuartile {
        lowerQuartile
        upperQuartile
      }
      stateQuartile {
        upperBound
        lowerQuartile
        upperQuartile
      }
      mostRecentFishAbundanceSurvey {
        abundanceRating
        surveyDate
        costPerUnitEffort
      }
    }
    keeperPotential
    mostRecentFishLengthSurvey {
      stateSurveyId
      surveyDate
      minimumLength
      weightedAverageLength
      maximumLength
    }
    trophyFishRecords {
      surveyYear
      largestSurveyedLength
    }
    fishType {
      ...fish_type_fragment
    }
    lastStocked
    stockingEffort
  }
  ${FishTypeFragment}
`

export const LakePreviewFragment = gql`
  fragment lake_preview_fragment on Lake {
    __typename
    id
    name
    area
    location
    maxDepth
    attributes
    latestFishSurveyYear
    trophyFish {
      slug
    }
    fishingAreasConnection {
      count
    }
    coverPhoto {
      contentUrl
    }
  }
`

export const LakeFragment = gql`
  fragment lake_fragment on Lake {
    __typename
    id
    name
    attributes
    area
    location
    extent
    maxDepth
    averageWaterClarity
    latestFishSurveyYear
    fishSurveySummaries {
      ...waterbody_species_fragment
    }
    amenities {
      name
      slug
    }
    waterAccessSites {
      id
    }
    fishingAuthorities {
      id
      createdAt
      fishingRegulationsURL
      logo {
        contentUrl
      }
      state {
        name
      }
    }
    additionalFishingRegulations {
      createdAt
      header(format: HTML)
      summary(format: HTML)
      fishingAuthority {
        id
        createdAt
        fishingRegulationsURL
        logo {
          contentUrl
        }
        state {
          name
        }
      }
    }
    stockingSummary {
      fishTypes {
        name
      }
      mostRecentStockingEvent
      yearsStocked
    }
    fishingReports(first: 3) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          publishedAt
          title
          subArea
          body
          publisher {
            name
            description
            copyright
            url
          }
          contributors {
            name
            telephones
            url
          }
          area {
            id
          }
        }
      }
    }
  }
  ${WaterbodySpeciesFragment}
`

export const WaterAccessFragment = gql`
  fragment water_access_fragment on WaterAccessSite {
    name
    id
    location
    amenities {
      name
      slug
    }
  }
`

export const WaterFeatureFragment = gql`
  fragment water_feature_fragment on WaterFeature {
    shortName
    parents {
      ... on WaterFeature {
        shortName
        slug
      }
    }
  }
`

export const FishingAreasListFragment = gql`
  fragment fishing_areas_list_fragment on FishingArea {
    id
    identifiers
    label
    name
    fishTypes {
      ...fish_type_fragment
    }
    waterFeatures {
      ...water_feature_fragment
    }
    nonNullableWaterbody: waterbody {
      ... on Lake {
        id
        name
      }
      ... on River {
        id
        name
      }
    }
  }
  ${FishTypeFragment}
  ${WaterFeatureFragment}
`
